module.exports = __webpack_public_path__ + "media/images/logo/vzvz_small-f8c8101c63c8bcd4c32fa1a2ba7fa0af.png";